import styled from "@emotion/styled";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import Colors from "styles/colors";
const HEADER_HEIGHT = 384;
const HEADER_WIDTH = 1040;
const WIDE_HEADER_WIDTH = 1200;
const HEADER_PADDING = 32;
const menuSectionTitleStyles = `
  color: #7c7b7b;
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
  line-height: 160%;
  letter-spacing: 0.96px;
  text-transform: uppercase;
`;
export const StyledShortHeaderMenuComponent = styled.div`
  background-color: ${Colors[WHITE_COLOR_NAME]};
  box-sizing: content-box;
  width: ${HEADER_WIDTH}px;
  height: ${HEADER_HEIGHT}px;
  padding: ${HEADER_PADDING}px;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  &.is-wide {
    width: ${WIDE_HEADER_WIDTH}px;
  }

  .menu-component {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 24px;
    justify-content: stretch;
    align-items: stretch;
    overflow-x: hidden;
    overflow-y: auto;

    .align-to-link {
      margin-left: 8px;
    }

    .menu-section-title,
    .menu-section-subtitle,
    .capabilities-main-title,
    .capability-group-title {
      ${menuSectionTitleStyles}
    }

    .capabilities-main-title {
      text-decoration: none;
    }
  }
`;
